import React, { useCallback, useRef } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import SearchFloatingPanel, { SearchFloatingPanelProps } from 'components/SearchV2/Components/Mobile/SearchFloatingPanel/SearchFloatingPanel'
import LocationSearchField from 'components/SearchV2/Components/Mobile/LocationSearchField/LocationSearchField'
import useFlightLocationSearchFieldProps from 'components/SearchV2/Hooks/useFlightLocationSearchFieldProps'
import FlightAirportFieldOption from './FlightAirportFieldOption'

const customComponents = {
  Option: FlightAirportFieldOption,
}

const ContentContainer = styled.div`
  display: flex;
  padding: ${rem(20)};
`

interface Props extends
  Omit<
    SearchFloatingPanelProps,
    'title' | 'confirmText' | 'isConfirmButtonHidden' | 'children'
  >
{
  isDeparture?: boolean;
}

const FlightLocationFloatingPanel = (props: Props) => {
  const { onConfirm, isDeparture } = props
  const selectRef = useRef(null)

  const onSelect = useCallback(() => {
    onConfirm()
  }, [onConfirm])

  const locationSearchProps = useFlightLocationSearchFieldProps({
    selectRef,
    onSelect,
    isDeparture,
  })

  return (
    <SearchFloatingPanel
      {...props}
      title={isDeparture ? 'Flying from?' : 'Flying to?'}
      isConfirmButtonHidden
    >
      <ContentContainer>
        <LocationSearchField
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={props.isOpen}
          menuIsOpen
          ref={selectRef}
          placeholder="Search destination"
          customComponents={customComponents}
          {...locationSearchProps}
        />
      </ContentContainer>
    </SearchFloatingPanel>
  )
}

export default FlightLocationFloatingPanel
